<template lang="pug">
UiStack(vertical)
  UiStack
    UiStackItem(fill)
      .ui-card-section-title {{ $t("companies.tabs.approvers") }}
    UiStackItem
      UiButton(
        variant="primary"
        @click="addApprover"
        icon="Plus"
      ) {{ $t("companies.approvers.add") }}

  RestTable(
    namespace="approvers"
    :headers="headers"
    ref="ApproversTable"
    :fetch-handler="getData"
    embed
  )
    template(#filters="{ filters, updateFilters }")
      UiStack
        UiStackItem
          UiFormGroup(
            :label="$t('companies.approvers.name')"
            label-for="name-input"
            label-cols="4"
          )
            UiInput#name-input(
              :modelValue="filters.search"
              type="search"
              @update:modelValue="updateFilters({ search: $event })"
              inputSize="30"
            )
    template(#cell:roles="{ item }")
      UiStack(spacing="xs")
        UiButton(
          v-if="item.is_approver"
          size="sm"
          variant="info"
        ) {{ $t("companies.approvers.role_approver") }}
        UiButton(
          v-if="item.is_verificator"
          size="sm"
        ) {{ $t("companies.approvers.role_verificator") }}
    template(#cell:assigned_to="{ item }")
      UiStack(spacing="xs")
        table.targets-table(
          v-if="Array.isArray(item.assigned_to) && item.assigned_to.length > 0"
        )
          thead
            tr
              th(v-for="column in columns(item.assigned_to)") {{ column }}
          tbody
            tr(v-for="row in rows(item.assigned_to)")
              td(v-for="column in columns(item.assigned_to)") {{ row[column] || "" }}
    template(#cell:actions="{ item }")
      UiStack(spacing="xs")
        UiButton(
          size="sm"
          variant="smooth-primary"
          @click="editApprover(item)"
          icon="PencilCreate"
        ) {{ $t("actions.edit") }}
        UiButton(
          size="sm"
          variant="smooth-danger"
          @click="deleteApprover(item)"
          icon="Trash"
        ) {{ $t("actions.delete") }}

  EditApproverModal(
    ref="EditApproverModal"
    @done="reload"
  )
</template>

<script>
import ApiApprovers from "@/api/approvers.js";
import EditApproverModal from "@/modals/Companies/editApprover.vue";

export default {
  components: {
    EditApproverModal,
  },

  data() {
    return {
      headers: [
        {
          key: "id",
          label: "#",
          sortable: true,
          squeeze: true,
        },
        {
          key: "approver_name",
          label: "Name",
          sortable: true,
          width: "10%",
          cellClass: "text-nowrap",
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          width: "10%",
          cellClass: "text-nowrap",
        },
        {
          key: "price_limit",
          label: "Max approval limit",
          sortable: true,
          width: "10%",
          cellClass: "text-nowrap",
        },
        {
          key: "roles",
          label: "Roles",
          width: "25%",
        },
        {
          key: "assigned_to",
          label: "Assigned",
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },

  methods: {
    reload() {
      this.$refs.ApproversTable.fetchData();
    },
    getData(params, config) {
      return ApiApprovers.fetchApprovers(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.approvers,
          meta: resp.data.meta,
        };
      });
    },

    addApprover() {
      this.$refs.EditApproverModal.open(this.$route.params.id, null);
    },

    editApprover(item) {
      this.$refs.EditApproverModal.open(this.$route.params.id, item);
    },

    deleteApprover(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "account-minus",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiApprovers.deleteApprover(this.$route.params.id, item.id).then(
          (resp) => {
            this.reload();
          },
        );
      });
    },

    rows(data) {
      const rows = [];
      for (const [col, val] of data) {
        const row = rows.find((row) => !row[col]);
        if (row) {
          row[col] = val;
        } else {
          const newRow = { [col]: val };
          rows.push(newRow);
        }
      }
      return rows;
    },

    columns(data) {
      return Array.from(new Set(data.map(([item]) => item)));
    },
  },
};
</script>
